import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { useLocation, useParams } from "react-router-dom";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

//reducer
import * as actions from "./actions";

//components
import PageNotFound from "../../../../common/PageNotFound";
import Spinner from "../../../../common/Spinner";
import AppHoc from "../../../../generics/AppHOC";
import ErrorComponent from "../../../../common/ErrorComponent";

//utils
import { getReportsHeader, getSiteName, getSiteId } from "../../../../../src/utils/common";
import { timeFilterTypesCustomV4, isSpecificSiteSelection } from "../../../../utils/enums";
import { formatDate, shortDisplayDate24HourWithSec } from "../../../../utils/displayTime";
import css from "../../reportsMagneticStyle.less";
import TimeStamp from "../../../../generics/TimeStamp";
import { useI18n } from "../../../../i18n/useI18n";
import SlaReportView from "../../../circuits/SlaReportView";
import apiService from "../../../../config/api-config";
import { useMount } from "../../../../utils/genericCommon";

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

const mapStateToProps = state => {
  return {
    linkSLA: state.vanalytics.linkSLA
  };
};

const LinkSLA = props => {
  const { tViews } = useI18n('views');
  const [siteInfoData, setSiteInfoData] = useState(tViews('reportTemplatesSites'));
  const [isSiteNameSet, setSiteNameSet] = useState(false);
  const envVarForReports = process.env.REACT_APP_SKIP_RBAC_DISABLE_RBAC;
  const { id: reportId } = useParams();
  const location = useLocation();
  const mount = useMount();
  
  useEffect(() => {
    const { getReportData } = props.actions;
    getReportData(reportId);
  }, []);

  // to get selected sitename from the site id
  const setSiteID = async (selectedSiteId) => {
    if (
      isSpecificSiteSelection(selectedSiteId) &&
      mount.initMount
    ) {
      mount.initMount = false;
      const sitesResult = await apiService.getSites();
      if (sitesResult?.data?.data?.length > 0) {
        const siteInfo = sitesResult.data.data;
        const siteData = getSiteName('report', siteInfo, selectedSiteId);
        setSiteInfoData(siteData);
        setSiteNameSet(true);
      } else {
        setSiteInfoData(tViews('reportTemplatesSites'));
        setSiteNameSet(true);
      }
    }
  }

  if (props.linkSLA.reportLoader) {
    return <Spinner />;
  } else if (props.linkSLA.errorReportData) {
    return (
      <ErrorComponent
        {...props.linkSLA.errorMessage}
        width={"210px"}
        className={"small-dashlet-error"}
      />
    );
  } else if (props.linkSLA.reportData.data.length > 0) {
    const reportData = props.linkSLA.reportData.data[0];

    const {
      current_period_start,
      current_period_end,
      time_range,
    } = reportData;

    // siteid converted to numbers, if site_id coming as numbers string seperated by comma e,g ["1,2"] -> [1,2]
    const site_id = getSiteId(reportData);
    let globalV4PayloadReport = {
      time_frame: timeFilterTypesCustomV4[time_range],
      entry_ts: {
        start: shortDisplayDate24HourWithSec(formatDate(current_period_start).utc()),
        end: shortDisplayDate24HourWithSec(formatDate(current_period_end).utc())
      }
    };
    setSiteID(site_id);
    // when site_id is not all, then only pass site_id to payload
    if (isSpecificSiteSelection(site_id)) {
      globalV4PayloadReport["site_id"] = site_id;
    }

    //by default is_debug is false and report browser link is disable/block to show reports
    if (envVarForReports === "FALSE") {
      if (reportData && !reportData?.is_debug) {
        return <PageNotFound />;
      }
    }

    return (
      <div className={css.linkSLA}>
        {getReportsHeader(reportData.overlay_name, location)}
        <div className="sla-scope-section">
          <span className="details">
            <span className="title hbr-type-body3">{tViews('sitesLabel')}</span>
            <span className="value hbr-type-body3">{siteInfoData}</span>
          </span>
          <TimeStamp {...props} isReport={true} reportData={props.linkSLA.reportData.data[0]} />
        </div>
        <div className="sla-scope-section">
          <span className="details">
            <span className="value hbr-type-body3"> {tViews('linkSLALabel')}</span>
          </span>
        </div>
        <SlaReportView
          globalV4PayloadReport={globalV4PayloadReport}
          siteNameSet={isSiteNameSet}
          min={current_period_start}
          max={current_period_end}
        ></SlaReportView>
      </div>
    );
  } else {
    return <PageNotFound />;
  }
};

LinkSLA.propTypes = {
  linkSLA: PropTypes.object.isRequired,
  actions: PropTypes.object
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHoc(LinkSLA))
);
